import { createAction, props } from '@ngrx/store';
import { ZoneSubscription } from '../../../zones/models/zone-subscription';
import { ChangeStateModel } from '../../../zones/models/change-state-model';
import { CreateZoneGroupModel, ZoneGroup } from 'src/app/zones/models/zone-group';

export const getZonesSubscriptionGroups = createAction(
  '[ZonesSubscriptionsGroups] Get Zones Subscription Groups'
);
export const createZoneSubscriptionGroup = createAction(
  '[ZonesSubscriptionsGroups] Create Zone Subscription Group',
  props<{data: CreateZoneGroupModel}>()
);
export const editZoneSubscriptionGroup = createAction(
  '[ZonesSubscriptionsGroups] Edit Zone Subscription Group',
  props<{groupName: string}>()
);
// export const deleteZoneSubscription = createAction(
//   '[ZonesSubscriptions] Delete Zone Subscription Group',
//   props<{zoneId: number}>()
// );
export const assignZoneToGroup = createAction(
  '[ZonesSubscriptionsGroups] Assign zone to group',
  props<{zoneId: number, zoneGroupId: number}>()
);
export const unassignZoneToGroup = createAction(
  '[ZonesSubscriptionsGroups] Unassign zone from group',
  props<{zoneId: number, zoneGroupId: number}>()
);

export type ZonesSubscriptionGroupsActionsUnion = ReturnType<
  typeof getZonesSubscriptionGroups
  >;
